import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum CatalogFilterName {
  SALES_CHANNEL = "salesChannel",
  STATUS = "status",
  VENDOR = "vendor",
  SKU = "sku",
  PRICE_RANGE = "priceRange",
}

export const getCatalogUniqueValues = {
  name: "getCatalogUniqueValues" as const,
  input: z.object({
    filterName: createEnum(CatalogFilterName),
    filterSearch: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
    limit: z.number().min(1).max(500).default(100).optional(),
  }),
  output: z.object({
    values: z.array(z.string()),
    totalCount: z.number(),
    hasMore: z.boolean(),
  }),
};
